import { render } from "./technologyPage.vue?vue&type=template&id=9a8172b4"
import script from "./technologyPage.vue?vue&type=script&lang=js"
export * from "./technologyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__